import styled from 'styled-components';

export const MLErrorWrapper = styled.div`
  padding-left: 10px;
  &::before {
    content: '• ';
  }
`;

export const MLErrorItem = styled.div`
  padding-left: 10px;
`;
